const featuredCategories = [
  {
    name: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20sneaker%20collection%20displayed%20on%20a%20polished%20concrete%20pedestal%20with%20dramatic%20side%20lighting%20creating%20bold%20shadows%20rich%20textures%20visible%20leather%20details%20urban%20gallery%20aesthetic%20high%20end%20editorial%20style%20dark%20moody%20atmosphere%20with%20warm%20accent%20light&width=800&height=840&seq=featured-shoes-v2-2026&orientation=portrait",
    size: "large",
  },
  {
    name: "Bluzy/Swetry",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20in%20warm%20terracotta%20tone%20draped%20artistically%20over%20a%20vintage%20wooden%20chair%20with%20soft%20amber%20evening%20light%20streaming%20through%20a%20window%20creating%20a%20warm%20nostalgic%20atmosphere%20lifestyle%20photography%20with%20film%20grain%20texture&width=800&height=400&seq=featured-hoodies-v2-2026&orientation=landscape",
    size: "small",
  },
  {
    name: "T-Shirty",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Street%20style%20graphic%20t-shirts%20artfully%20arranged%20on%20a%20rustic%20wooden%20bench%20against%20an%20exposed%20brick%20wall%20with%20industrial%20loft%20vibes%20edgy%20editorial%20fashion%20photography%20bold%20colors%20contrasting%20with%20raw%20textures%20urban%20cool%20aesthetic&width=800&height=400&seq=featured-tshirts-v2-2026&orientation=landscape",
    size: "small",
  },
];

export default function CategoryGrid() {
  return (
    <section id="kategorie" className="py-20 md:py-28 bg-background-50 scroll-mt-16 md:scroll-mt-[72px]">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-center text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
          Popularne{" "}
          <span className="text-primary-500">Kategorie</span>
        </h2>
        <p className="text-center text-sm text-foreground-500 mb-14 max-w-lg mx-auto">
          Odkryj najczęściej wybierane kategorie produktów w kakobuy spreadsheet
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-6">
          <a
            href={featuredCategories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative group rounded-2xl overflow-hidden h-[320px] md:h-[420px] cursor-pointer"
          >
            <img
              src={featuredCategories[0].imageUrl}
              alt="Buty - Kakobuy Spreadsheet"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <span className="inline-block px-3 py-1.5 bg-white/25 backdrop-blur-sm rounded-full text-white text-sm font-medium">
                {featuredCategories[0].name}
              </span>
            </div>
          </a>

          <div className="flex flex-col gap-4 md:gap-5">
            <a
              href={featuredCategories[1].url}
              target="_blank"
              rel="noopener nofollow"
              className="relative group rounded-2xl overflow-hidden h-[152px] md:h-[200px] cursor-pointer"
            >
              <img
                src={featuredCategories[1].imageUrl}
                alt="Bluzy i Swetry - Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1.5 bg-white/25 backdrop-blur-sm rounded-full text-white text-sm font-medium">
                  {featuredCategories[1].name}
                </span>
              </div>
            </a>

            <a
              href={featuredCategories[2].url}
              target="_blank"
              rel="noopener nofollow"
              className="relative group rounded-2xl overflow-hidden h-[152px] md:h-[200px] cursor-pointer"
            >
              <img
                src={featuredCategories[2].imageUrl}
                alt="T-Shirty - Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1.5 bg-white/25 backdrop-blur-sm rounded-full text-white text-sm font-medium">
                  {featuredCategories[2].name}
                </span>
              </div>
            </a>
          </div>
        </div>

        <div className="text-center mt-10">
          <p className="text-xs text-foreground-500 mb-4">
            Kliknij dowolną kategorię, aby przejść do pełnej listy produktów na kaspreadsheet.com
          </p>
        </div>
      </div>
    </section>
  );
}